export default "__VITE_ASSET__BZR3Has8__"